import socketTypes from './socketTypes';
import { connect } from '../../services/socketService';
import {
  addNotification,
  updateNotificationCounts,
} from '../notification/notificationActions';

const setupSocketHandlers = (socket, dispatch) => {
  const handleNotification = (notification, counts) => {
    if (notification) {
      dispatch(addNotification(notification));
    }
    if (counts) {
      dispatch(updateNotificationCounts(counts));
    }
  };

  const handleCounts = (counts) => dispatch(updateNotificationCounts(counts));

  socket.on('ReceiveNotification', handleNotification);
  socket.on('UpdateCounts', handleCounts);

  return () => {
    socket.off('ReceiveNotification', handleNotification);
    socket.off('UpdateCounts', handleCounts);
  };
};

export const connectSocket = (token) => (dispatch, getState) => {
  if (!token) {
    return;
  }

  if (getState().socket?.socket) {
    dispatch({ type: socketTypes.DISCONNECT });
  }

  const socket = connect(token);
  const cleanup = setupSocketHandlers(socket, dispatch);

  dispatch({
    type: socketTypes.CONNECT,
    payload: { socket, cleanup },
  });
};

export const disconnectSocket = () => ({
  type: socketTypes.DISCONNECT,
});
